import { render, staticRenderFns } from "./投诉与回复.vue?vue&type=template&id=38586abf&scoped=true"
import script from "./投诉与回复.vue?vue&type=script&lang=js"
export * from "./投诉与回复.vue?vue&type=script&lang=js"
import style0 from "./投诉与回复.vue?vue&type=style&index=0&id=38586abf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38586abf",
  null
  
)

export default component.exports